import Canvas from "./components/Canvas";
import "./App.css";

const App = () => {
  return (
    <div className="flex h-full">
      <Canvas />
    </div>
  );
};

export default App;
